"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandDeepLink = exports.getRBIDomain = exports.localeToTldMap = exports.Tld = exports.getDomain = exports.Domains = void 0;
const brand_1 = require("./brand");
const country_code_1 = require("./country-code");
var Domains;
(function (Domains) {
    Domains["BK_CA"] = "www.burgerking.ca";
    Domains["BK"] = "www.bk.com";
})(Domains || (exports.Domains = Domains = {}));
const BRAND_DEEP_LINK_PREFIX = 'burgerking://';
/**
 * Return the production domain for the configured brand
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getDomain = (brand, locale, _platform) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.BK_CA;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.BK;
                default:
                    return Domains.BK;
            }
        default:
            return Domains.BK;
    }
};
exports.getDomain = getDomain;
var Tld;
(function (Tld) {
    Tld["AQ"] = "io";
    Tld["AT"] = "at";
    Tld["CA"] = "ca";
    Tld["CH"] = "ch";
    Tld["CZ"] = "cz";
    Tld["DE"] = "de";
    Tld["ES"] = "es";
    Tld["FR"] = "fr";
    Tld["GB"] = "co.uk";
    Tld["ID"] = "id";
    Tld["JP"] = "jp";
    Tld["KR"] = "co.kr";
    Tld["MY"] = "my";
    Tld["NL"] = "nl";
    Tld["NZ"] = "co.nz";
    Tld["PL"] = "pl";
    Tld["PT"] = "pt";
    Tld["RO"] = "ro";
    Tld["SG"] = "com.sg";
    Tld["TH"] = "th";
    Tld["TW"] = "tw";
    Tld["US"] = "com";
    Tld["ZA"] = "co.za";
})(Tld || (exports.Tld = Tld = {}));
exports.localeToTldMap = new Map([
    [country_code_1.IsoCountryCode2Char.AQ, Tld.AQ],
    [country_code_1.IsoCountryCode2Char.AT, Tld.AT],
    [country_code_1.IsoCountryCode2Char.CA, Tld.CA],
    [country_code_1.IsoCountryCode2Char.CH, Tld.CH],
    [country_code_1.IsoCountryCode2Char.CZ, Tld.CZ],
    [country_code_1.IsoCountryCode2Char.DE, Tld.DE],
    [country_code_1.IsoCountryCode2Char.ES, Tld.ES],
    [country_code_1.IsoCountryCode2Char.FR, Tld.FR],
    [country_code_1.IsoCountryCode2Char.GB, Tld.GB],
    [country_code_1.IsoCountryCode2Char.ID, Tld.ID],
    [country_code_1.IsoCountryCode2Char.JP, Tld.JP],
    [country_code_1.IsoCountryCode2Char.KR, Tld.KR],
    [country_code_1.IsoCountryCode2Char.MY, Tld.MY],
    [country_code_1.IsoCountryCode2Char.NL, Tld.NL],
    [country_code_1.IsoCountryCode2Char.NZ, Tld.NZ],
    [country_code_1.IsoCountryCode2Char.PL, Tld.PL],
    [country_code_1.IsoCountryCode2Char.PT, Tld.PT],
    [country_code_1.IsoCountryCode2Char.RO, Tld.RO],
    [country_code_1.IsoCountryCode2Char.SG, Tld.SG],
    [country_code_1.IsoCountryCode2Char.TH, Tld.TH],
    [country_code_1.IsoCountryCode2Char.TW, Tld.TW],
    [country_code_1.IsoCountryCode2Char.US, Tld.US],
    [country_code_1.IsoCountryCode2Char.ZA, Tld.ZA],
]);
/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */
const getRBIDomain = (brand, stage, locale) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    const tld = exports.localeToTldMap.get(normalizedLocale);
    if (!tld) {
        throw new Error(`Unsupported country code ${normalizedLocale}`);
    }
    return `${stage}-${brand.toLowerCase()}-web.${tld}.rbi.tools`;
};
exports.getRBIDomain = getRBIDomain;
/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */
const getBrandDeepLink = () => {
    return BRAND_DEEP_LINK_PREFIX;
};
exports.getBrandDeepLink = getBrandDeepLink;
//# sourceMappingURL=domains.js.map